import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../services/general.service';
import { EmployeeService } from '../../../../services/employee.service';
import { exit } from 'process';

declare var $: any;

@Component({
  selector: 'app-skills-department-create',
  templateUrl: './skills-department-create.component.html',
  styleUrls: ['./skills-department-create.component.css']
})
export class SkillsDepartmentCreateComponent implements OnInit {

  @Input() ID: string;
  @Input() PID: string;
  @Input() langs: string;

  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  frequencyConfig: any;
  LevelCompetence: any;
  RepTypes: any;

  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  maintenance_plans: any;
  employee_skills: any;
  app_maintenance_plans: any;
  skills: any;
  skills_records: any;
  emp_skills: any;
  app_emp_id: any;
  lang: any;
  generalLang: any;
  record: any;
  mode: string;
  StatusData: any;

  imageLink: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private employeeService: EmployeeService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    console.log("ID===>"+this.ID)
    this.FormBuild()
    this.getData();    
  }

  FormBuild(): void {
    this.createForm = this.formBuilder.group({
      code: ['', [Validators.required]],
      description: ['', [Validators.required]]
    });
  }

  onSubmit() {
    console.log(this.createForm.value); 
    // console.log(this.createForm.value); return false;
    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

      // console.log('test12'); return false;

    this.employeeService.addSkillAnaylsisDepartment(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();

          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.SKILLS_LIST]);
            });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  getData() {
    this.employeeService.getSkillEmployees(this.ID,'')
        .subscribe(
          (res) => {
            this.skills = res.data.skills;
            this.emp_skills = res.data.emp_skills;
            this.lang = this.employeeService.createLang(res);
          }
        );
      this.generalLang = this.langs;
      this.mode = 'Create';
      this.modalTitle = 'SKILL CREATION';
    }
}
